import axios from 'axios';
import React, { useState } from 'react';
import { Underline,Floatinmenu } from "../../widgets";
import { admin_menu } from "../../constants/dashboard";
import './ForgetPassword.css';
import './Studentresult.css';


export default function Studentresult() {
      const [reg_no, setRegno] = useState('');
    const [response, setResponse] = useState('');
  const handleChangeRegno = (e) => setRegno(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reg_no) {
      alert("Please enter a register number");
      return;
    }

    const data = { reg_no };
console.log("Data to be sent:", data);
    try {
      const response = await axios.post('/backend/showdbresults', data);
      setResponse(response.data); 
    } catch (error) {
      console.error("Error:", error);
    }
  };
    return (
        <>
        <div className='forgetpassword'>
            <Underline heading={"Student Result IN DB"} />
            <Floatinmenu head="Menu" links={admin_menu} />
            <div className='forgetpass_div'>
                <input 
                    className='password_regno' 
                    type="number" 
                    placeholder='Enter Regno' 
                    value={reg_no}
                    onChange={handleChangeRegno}
                />
                <button onClick={handleSubmit}>Enter</button>
            </div>
            {response && response.success && Array.isArray(response.data) && (
                <div className='response_div'>
                    <h3>Results:</h3>
                    <table className="result-table">
                        <thead>
                            <tr>
                                <th>Reg No</th>
                                <th>Sub Code</th>
                                <th>Semester</th>
                                <th>Grade</th>
                                <th>Result</th>
                                <th>Current Sem</th>
                            </tr>
                        </thead>
                        <tbody>
                            {response.data.map((row, idx) => (
                                <tr key={idx}>
                                    <td>{row.regno}</td>
                                    <td>{row.subcode}</td>
                                    <td>{row.sem}</td>
                                    <td>{row.grade}</td>
                                    <td>{row.result}</td>
                                    <td>{row.current_sem}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {response && !response.success && (
                <div className='response_div'>
                    <h3>Error:</h3>
                    <pre>{JSON.stringify(response, null, 2)}</pre>
                </div>
            )}
            <div className="logout_button">
                <a className="log_link" href="/logout">
                    Logout
                </a>
            </div>
        </div>
       
        </>
    )
}